import { Action } from 'redux';

import { EnterSimulationSubspace } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { ISimulationDetailWithUsageInfo } from '~src/simulation/models/ISimulationInfo';
import { SimulationSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

export interface EnterSimulationSubspaceReduxAction extends Action {
  readonly simulationDetailInfo: ISimulationDetailWithUsageInfo;
  readonly subspaceName: SimulationSubspaceName;
}

export function enterSimulationSubspace(
  simulationDetailInfo: ISimulationDetailWithUsageInfo,
  subspaceName: SimulationSubspaceName
): EnterSimulationSubspaceReduxAction {
  return {
    type: EnterSimulationSubspace,
    simulationDetailInfo,
    subspaceName
  };
}

export const isEnterSimulationSubspaceAction = isActionFactory<EnterSimulationSubspaceReduxAction>(EnterSimulationSubspace);
